import React from "react";
import { EnvelopeOpenIcon } from "@heroicons/react/24/outline";

interface GeneralNotificationProps {
  title: string;
  description: string;
  time: string;
  isRead: boolean;
  setIsRead?: (isRead: boolean) => void;
}

const GeneralNotification: React.FC<GeneralNotificationProps> = ({
  title,
  description,
  time,
  setIsRead,
  isRead

}) => {
  

  return (
    <div className="bg-white dark:bg-gray-800 p-6 shadow-lg rounded-lg max-w-[800px] mx-auto mt-5">
      <h2 className="text-xl font-bold mb-2 dark:text-white">{title}</h2>
      <p className="dark:text-gray-300">{description}</p>
      <p className="text-sm text-gray-300 dark:text-gray-400">{time}</p>
      <div className="mt-4">
        <div className="mt-2 text-sm text-gray-500 dark:text-gray-400 flex flex-row justify-between">
          Status: {isRead ? "Read" : "Unread"}
          {!isRead && (
            <div className="flex justify-end">
              <button
                onClick={() => setIsRead && setIsRead(true)}
                className="mr-2 bg-transparent text-blue-500 dark:text-blue-400"
                disabled={isRead}
                title="Mark as read"
              >
                <EnvelopeOpenIcon className="h-6 w-6 text-blue-500" />
              </button>
            </div>
          )}
        </div>
      </div>
    </div>
  );
};

export default GeneralNotification;
